module.exports = __webpack_public_path__ + "media/images/thumb/flags/16/WS-b850f4dc552f21a79e4a1ec1bc271af2.png";